import { useMutation } from 'urql';
import { CreateFileInput, Mutation } from 'api';
import { CREATE_DIRECTORY_FILE_MUTATION } from 'api/graphql/mutations/directory';

type MutationType = Pick<Mutation, 'createFile'>;

export const useCreateFile = () => {
    const [state, executeMutation] = useMutation<MutationType>(CREATE_DIRECTORY_FILE_MUTATION);

    const createFile = async (input: CreateFileInput) => {
        const { error, data } = await executeMutation({ input });

        if (error) {
            return { error: error.graphQLErrors[0].extensions?.code };
        }

        return { data };
    };

    return {
        state,
        createFile,
    };
};
